import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useAppSelector} from '../../../hooks/runtime'
import {getReservations} from '../../../selectors/checkout'
import {SeatTicket} from './seat-ticket'
import {Ticket} from './ticket'
import s from './tickets-summary.scss'
import {TotalBreakdown} from './total-breakdown/total-breakdown'

export const TicketsSummary = () => {
  const reservations = useAppSelector(getReservations)
  const hasSeats = reservations.some(({ticketDetails: ticketsDetails}) =>
    ticketsDetails.some(ticketDetails => ticketDetails?.seatId),
  )

  return (
    <div className={s.container} data-hook={DH.TICKETS_SUMMARY}>
      {reservations.map(({ticket, ticketDetails: ticketsDetails, quantity}) =>
        ticketsDetails.length > 0 ? (
          ticketsDetails.map(ticketDetails =>
            hasSeats ? (
              Array.from({length: ticketDetails.capacity ?? 1}).map((_, idx) => (
                <SeatTicket key={`${ticketDetails.seatId}-${idx}`} ticket={ticket} ticketDetails={ticketDetails} />
              ))
            ) : (
              <Ticket
                key={ticketDetails.pricingOptionId ?? ticket.id}
                ticket={ticket}
                ticketDetails={ticketDetails}
                quantity={quantity}
              />
            ),
          )
        ) : (
          <Ticket key={ticket.id} ticket={ticket} quantity={quantity} />
        ),
      )}
      <TotalBreakdown />
    </div>
  )
}
